<template>
  <span v-if="job">
    <jobable-claim-reference :job="job"></jobable-claim-reference> -
    {{ job.type?.label }} -
    <template v-if="job.vehicle?.registration"
      >{{ job.vehicle?.registration.toUpperCase() }} - </template
    >{{ job.location }} - {{ job.date | date }}
  </span>
</template>

<script>
import JobableClaimReference from '@/components/Modules/Job/Children/JobableClaimReference.vue';

export default {
  components: { JobableClaimReference },
  props: {
    job: {
      type: Object,
      required: true
    }
  }
};
</script>
